import validate from "/home/circleci/repo/node_modules/nuxt/dist/pages/runtime/validate.js";
import authentication_45required_45global from "/home/circleci/repo/out/apps/global-admin-panel/application/middleware/authentication-required.global.ts";
import manifest_45route_45rule from "/home/circleci/repo/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  authentication_45required_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}